import axios from 'axios';

// Default kept in sync with this project's convention (backend on 9008,
// frontend on 9007) — override by setting REACT_APP_API_URL in your .env,
// which always wins.
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:9008';

export default axios.create({
  baseURL: API_URL,
});